import { TagProps } from '@superdispatch/ui';
import { ReactNode } from 'react';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { PostingCarrierLoadDTO } from '../../data/dto/PostingDTO';

interface CarrierPostingStatusInfo {
  text: ReactNode;
  color: TagProps['color'];
  variant: 'subtle' | 'bold';
}

const carrierPostingStatusInfo: Record<
  PostingCarrierLoadDTO['status'],
  undefined | CarrierPostingStatusInfo
> = {
  UNPOSTED: { text: 'Unposted', color: 'grey', variant: 'subtle' },
  OFFER_SENT: { text: 'Load Offer Received', color: 'blue', variant: 'subtle' },
  COUNTER_OFFER_SENT: {
    text: 'Counter Offer Received',
    color: 'blue',
    variant: 'subtle',
  },
  REQUEST_DECLINED_BY_BROKER: {
    text: 'Shipper Declined Request',
    color: 'grey',
    variant: 'subtle',
  },
  OFFER_ACCEPTED: { text: 'Booked', color: 'green', variant: 'subtle' },
  REQUEST_PENDING: { text: 'Request Sent', color: 'yellow', variant: 'subtle' },
  REQUEST_CANCELED: {
    text: 'Request Canceled',
    color: 'grey',
    variant: 'subtle',
  },
  OFFER_CANCELED: { text: 'Offer Canceled', color: 'grey', variant: 'subtle' },
  OFFER_DECLINED: {
    text: 'Load Offer Declined',
    color: 'grey',
    variant: 'subtle',
  },
};

export function getCarrierPostingDetails({
  price,
  status,
  counter_offer_price,
}: PostingCarrierLoadDTO): CarrierPostingStatusInfo {
  const statusInfo = carrierPostingStatusInfo[status];

  if (!statusInfo) {
    return { text: status, color: 'grey', variant: 'subtle' };
  }

  switch (status) {
    case 'REQUEST_PENDING':
    case 'REQUEST_DECLINED_BY_BROKER':
      return {
        ...statusInfo,
        text: (
          <>
            {statusInfo.text} for{' '}
            {formatCurrency(price, { minimumFractionDigits: 0 })}
          </>
        ),
      };

    case 'COUNTER_OFFER_SENT':
      return {
        ...statusInfo,
        text: (
          <>
            {statusInfo.text} for{' '}
            {formatCurrency(counter_offer_price, { minimumFractionDigits: 0 })}
          </>
        ),
      };
    default:
      return statusInfo;
  }
}
